<template>
  <div class="HeaderIcon2Configer">
    <div class="p-line"></div>
    <!-- 是否开启 -->
    <div class="is-show-right">
      <p>是否开启图标2链接</p>
      <el-switch
        v-model="value.isShowIcon"
        active-color="#1989fa"
        size="mini"
        inactive-color="#333"
        @change="handleSwitchChange"
      >
      </el-switch>
    </div>
    <!-- 图片上传 -->
    <div class="PicturesUploader" v-if="value.isShowIcon">
      <div class="p-header">图片管理器</div>
      <div class="p-body">
        <el-upload
          class="upload-demo"
          name="Filedata"
          :action="uploadAction()"
          :data="{ row_id: userRowID }"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button class="upload-pic-emmit" size="mini" type="primary">点击上传</el-button>
          <template #tip>
            <!-- <div class="el-upload__tip">
          只能上传 jpg/png 文件，且不超过 500kb
        </div> -->
          </template>
        </el-upload>

        <el-popover placement="bottom" popper-class="files-selector" :width="270" trigger="click">
          <div class="file-show-list">
            <div
              class="file-item"
              v-for="item in uploadedFileList"
              :key="item"
              @click="handleFileSelect(item)"
            >
              <img :src="item" />
            </div>
          </div>
          <template #reference>
            <el-button size="mini" class="upload-pic-manager" @click="getFilesList">图片选择</el-button>
          </template>
        </el-popover>
        <!-- <el-button class="upload-pic-manager" size="mini">图片管理</el-button> -->
      </div>
    </div>
    <!-- 链接地址 -->
    <div class="url" v-if="value.isShowIcon">
      <div class="u-header">链接地址</div>
      <div class="u-body">
        <el-input v-model="value.url" @change="handleChange" placeholder="请输入"></el-input>
      </div>
    </div>
    <!-- 链接名称 -->
    <div class="url" v-if="value.isShowIcon">
      <div class="u-header">链接名称</div>
      <div class="u-body">
        <el-input v-model="value.name" @change="handleChangeName" placeholder="请输入"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../../../apis/api';
import { request } from '../../../common/request';
const path = require('path');
export default {
  name: 'HeaderIcon2Configer',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      value: this.propertyData.headerIcon2.value,
      // 图片
      fileList: [],
      uploadedFileList: [],
      userRowID: '',
      isOpenFileManager: false,
      inputValue: '', // 输入的链接
    };
  },
  components: {},
  mounted() {
    /* 获取初始值 */
    this.setUserRowID();
  },
  methods: {
    changeSetting() {
      /* 更新数据 */

      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
    handleSwitchChange(e) {
      if (!e) {
        this.value.iconUrl = '';
        this.value.url = '';
        this.changeSetting();
      }
    },
    handleFileSelect(url) {
      console.log(url, 'url url +++++');
      this.value.iconUrl = url;
      this.changeSetting();
    },
    handleChange(url) {
      this.value.url = url;
      this.changeSetting();
    },
    handleChangeName(name) {
      this.value.name = name;
      this.changeSetting();
    },
    uploadAction() {
      return Api.imageUpload;
    },
    getFilesList() {
      // const url = `${Api.getFilesList}&type=image&row_id=${this.userRowID}`;
      // http://localhost/bigdatadisplaysystem_php/back/gthmmc/index.php?m=bdds&c=uploadWeb&a=getBgmaterial&type=image&row_id=4
      // console.log(url,'545454545454545');
      let params = {
        method: 'post',
        url: Api.getFilesList + '&type=image&row_id=' + this.userRowID,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      };
      request(params).then(res => {
        if (res?.data?.list) {
          console.log(res?.data?.list, '请求+++++');
          this.uploadedFileList = res?.data?.list;
          // res?.data?.list.map(item => Api.host + item);
          // this.getDefaultImgs()
        } else {
          this.getDefaultImgs();
        }
      });
    },
    setUserRowID() {
      let info = window.localStorage.getItem('origin_userInfo');
      if (info) {
        let userinfo = JSON.parse(info);
        this.userRowID = userinfo.row_id;
      }
      // console.log('图片上传用户id', this.userRowID);
    },
    // 获取本地默认图片
    getDefaultImgs() {
      const fileNames = require.context('@public/defaultImg', true);
      let paths = [];
      fileNames.keys().forEach(key => {
        paths.push('./defaultImg/' + path.basename(key));
      });
      this.uploadedFileList = [...this.uploadedFileList, ...paths];
    },
  },
};
</script>
<style lang="scss">
body .el-popper.files-selector {
  background: #2d313b;
  border: 1px solid #575e62;
  max-height: 500px;
  overflow-y: auto;
  &::-webkit-scrollbar-thumb {
    background: #6c45b4 !important;
    width: 4px !important;
    height: 3px !important;
  }
  &::-webkit-scrollbar {
    width: 4px !important;
    height: 3px !important;
  }
  &::-webkit-scrollbar-track {
    background: #43455800;
  }

  & .el-popper__arrow::before {
    background: #2d313b;
    border: 1px solid #575e62;
  }
  .file-show-list {
    width: 100%;
    // height: 800px;
    display: flex;
    flex-wrap: wrap;

    justify-content: space-between;
    padding-top: 10px;
    .file-item {
      cursor: pointer;
      flex-shrink: 0;
      margin-bottom: 20px;
      width: 104px;
      height: 90px;
      background-color: #3e4a69;
      border: 1px solid #3179ff00;
      &:hover {
        border: 1px solid #6d62ff;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.HeaderIcon2Configer {
  // margin-top: 15px;
  padding: 20px 15px 0;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .is-show-right {
    box-sizing: border-box;
    // padding: 0 15px;
    width: 100%;
    height: 43px;
    color: #a0a1b4;
    font-size: 14px;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-select {
      width: 192px;

      :deep() input {
        color: #ffffff;
        background: #191b23;
        border-radius: 0;
        border-collapse: collapse;
        text-align: center;
        border: 1px solid rgb(90, 90, 90);

        &:hover {
          border: 1px solid #3179ff;
        }
        &:focus {
          border: 1px solid #3179ff;
        }
      }
    }
  }
}
:deep().el-switch {
  margin: auto 0;
  .el-switch__core {
    background: #55597b;
    border: none;
    height: 10px;
    width: 30px !important;
    .el-switch__action {
      top: -2px;

      background: #c9cae5;

      width: 14px;
      height: 14px;
    }
  }
  &.is-checked {
    .el-switch__core {
      background: linear-gradient(143deg, #335ae9, #6f6ff5);
      .el-switch__action {
        left: 100%;
        background: #ffffff;
        margin-left: -14px;
      }
    }
  }
}

.PicturesUploader {
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;

  .p-header {
    box-sizing: border-box;
    // padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }
  .p-body {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0px;
    position: relative;
    :deep().el-upload-list__item:first-child {
      margin-top: 20px !important;
    }
    :deep().el-upload-list__item {
      background-color: rgb(63, 67, 75);
      color: white;
      border: 1px solid rgb(171, 120, 253);
      .el-upload-list__item-name {
        color: white;
      }
    }
    :deep().upload-demo {
      .el-progress {
        margin-top: 0px;
        .el-progress__text {
          color: white;
          top: -17px !important;
        }
      }
    }

    .upload-pic-emmit {
      background: linear-gradient(143deg, #3651c5, #686dff);
      color: #ffffff;
      border: #595dcb 1px solid;
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: white;
        box-shadow: 1px 1px 1px rgb(24, 24, 24);
      }
    }

    .upload-pic-manager {
      position: absolute;
      top: 10px;
      right: 80px;
      background: linear-gradient(143deg, rgb(94, 70, 226), #15a1ffe8);
      color: #ffffff;
      border: #56bb03 0px solid;
      &:hover {
        background: linear-gradient(143deg, #7860ff, #15a1ff);
        color: white;
        // border: #56bb03 1px solid;
        box-shadow: 1px 1px 1px rgb(24, 24, 24);
      }
    }
  }
}
.url {
  box-sizing: border-box;
  // padding: 0 15px;
  width: 100%;
  // height: 30px;
  color: $property-title-color;
  font-size: $property-title-size;
  line-height: 30px;
  .u-body {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    // padding: 0 15px;
    :deep().el-input input {
      height: 35px;
      color: #b6b8cc;
      background: #191b23;
      text-align: center;
      border: 1px solid rgba(139, 139, 139, 0.733);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
